import { useContext, useRef, useState, useEffect } from "react";
import { Context } from "../../context/Context";
import "./Schedule.css";
import ScheduleHour from "../flatpickr/ScheduleHour";
import LinearSlider from "../equipments/Sliders/LinearSlider";
import Weekly from "./Weekly";
import SelectEquipmentModal from "../modals/SelectEquipmentModal";
import SelectScheduleOutputEquipmentModal from "../modals/SelectScheduleOutputEquipmentModal";
import EquipmentButtonIcons from "../../constants/EquipmentButtonIcon";
import ErrorToast from "../toasts/ErrorToast";
import { useNavigate } from "react-router-dom";
import { MqttContext } from "../../context/MQTTContext";
import provinces from "../../constants/Provinces";
import { delayAdvanceOptions } from "../../constants/DelayAdvanceValues";
import Select2 from "../select2/Select2";

const Schedule = () => {
  const { handleSelectEquipmentModal, scheduleEquipmentType, setScheduleEquipmentType } =
    useContext(Context);
  const { clients } = useContext(MqttContext);

  const [selectOutputModal, setSelectOutputModal] = useState(null);
  const [data, setData] = useState({
    icon: null,
    data: [],
    name: null,
    device: {},
  });
  const [fadeValue, setFadeValue] = useState(0);
  const [hourValue, setHourValue] = useState("00");
  const [minuteValue, setMinuteValue] = useState("00");
  const [selectedDays, setSelectedDays] = useState([]);
  const [scheduleName, setScheduleName] = useState("");
  
  const [scheduleMode, setScheduleMode] = useState("normal");
  const [selectedProvince, setSelectedProvince] = useState(provinces[0]?.id || 1);
  const [delayAdvance, setDelayAdvance] = useState(0);
  
  const [delayAdvanceDisplayValue, setDelayAdvanceDisplayValue] = useState("0");

  const navigate = useNavigate();
  const provinceSelectRef = useRef(null);
  const delayAdvanceSelectRef = useRef(null);

  const closeSelectEquipmentRef = useRef(null);
  const closeSelectOutputEquipmentRef = useRef(null);

  // گزینه‌های ساعت (00 تا 23)
  const hourOptions = [];
  for (let i = 0; i <= 23; i++) {
    const hourStr = i < 10 ? `0${i}` : `${i}`;
    hourOptions.push({ value: hourStr, name: hourStr });
  }

  // گزینه‌های دقیقه (00 تا 59)
  const minuteOptions = [];
  for (let i = 0; i <= 59; i++) {
    const minuteStr = i < 10 ? `0${i}` : `${i}`;
    minuteOptions.push({ value: minuteStr, name: minuteStr });
  }

  useEffect(() => {
    setDelayAdvanceDisplayValue(String(delayAdvance));
  }, [delayAdvance]);

  const handleSelectOutputEquipmentModal = (status) => {
    const modal = new window.bootstrap.Modal(selectOutputModal.current);
    status ? modal.show() : modal.hide();
  };

  const changeScheduleName = (e) => {
    if (e.target.value.length > 15) return;
    setScheduleName(e.target.value);
  };

  const handleDelayAdvanceChange = (value) => {
    const numValue = value == undefined || value == null || value == "" ? 0 : Number(value);
    setDelayAdvance(numValue);
    setDelayAdvanceDisplayValue(String(numValue));
  };

  const calcSelectedDays = () => {
    let data = [0, 0, 0, 0, 0, 0, 0, 0];
    selectedDays.forEach((day) => {
      if (day == "saturday") {
        data[0] = 1;
      }
      if (day == "sunday") {
        data[1] = 1;
      }
      if (day == "monday") {
        data[2] = 1;
      }
      if (day == "tuesday") {
        data[3] = 1;
      }
      if (day == "wednesday") {
        data[4] = 1;
      }
      if (day == "thursday") {
        data[5] = 1;
      }
      if (day == "friday") {
        data[6] = 1;
      }
    });
    return parseInt(data.reverse().join(""), 2);
  };

  function stringToBuffer(str, length = 15) {
    const trimmedStr = str.slice(0, length);
    const encoder = new TextEncoder();
    const utf8Array = encoder.encode(trimmedStr);
    const buffer = new Uint8Array(30);
    buffer.set(utf8Array.slice(0, 30));
    return buffer;
  }

  const concatenateStringAndBuffer = (str, buffer) => {
    let encoder = new TextEncoder();
    let encodedString = encoder.encode(str);
    let newBuffer = new Uint8Array(encodedString.length + buffer.byteLength);
    newBuffer.set(encodedString, 0);
    newBuffer.set(new Uint8Array(buffer), encodedString.length);
    return newBuffer;
  };

  const concatenateBuffers = (buffer1, buffer2) => {
    const concatenatedBuffer = new Uint8Array(
      buffer1.byteLength + buffer2.byteLength,
    );
    concatenatedBuffer.set(new Uint8Array(buffer1), 0);
    concatenatedBuffer.set(new Uint8Array(buffer2), buffer1.byteLength);
    return concatenatedBuffer.buffer;
  };

  const handleSubmit = () => {
    if (!scheduleName) {
      return ErrorToast("نام برنامه را وارد کنید");
    }
    if (!data.data.length) {
      return ErrorToast("دستور برنامه را وارد کنید");
    }

    if (
      data.device.type == 4 ||
      (data.device.type == 9 && data.digit !== undefined)
    ) {
      const lastIndex = data.data.length - 1;

      if (data.device.type == 4 || data.device.type == 9) {
        if (data.digit == 0 || data.digit == 1 || data.digit == 2) {
          data.data[lastIndex] = Number(fadeValue) + 110;
        }
        if (data.digit == 3 || data.digit == 4 || data.digit == 5) {
          data.data[lastIndex - 1] = Number(fadeValue) + 110;
        }
      }
    }

    let hour = Number(hourValue);
    let minute = Number(minuteValue);
    
    const isAstronomicalMode = scheduleMode != "normal" && (data.device.fw_version >= 18 || data.device.fw_version == 13 || data.device.fw_version == 14);
    
    if (isAstronomicalMode) {
      const province = provinces.find(p => p.id == selectedProvince);
      if (!province) {
        return ErrorToast("لطفاً مرکز استان را انتخاب کنید");
      }
      
      if (scheduleMode == "sunrise") {
        hour = province.sunriseVal;
      } else if (scheduleMode == "sunset") {
        hour = province.sunsetVal;
      }
      
      minute = delayAdvance;
    }

    let days = calcSelectedDays();
    let name = stringToBuffer(scheduleName);

    if (data.device.is_bus == 1) {
      if (!clients[data.device.bridge_device.id]) return;

      let buffer = new ArrayBuffer(data.data.length + 11);
      let asciiCode = new Uint8Array(buffer);
      asciiCode[0] = 14;
      asciiCode[1] = `${data.device.serial[0]}`.charCodeAt(0);
      asciiCode[2] = `${data.device.serial[1]}`.charCodeAt(0);
      asciiCode[3] = `${data.device.serial[2]}`.charCodeAt(0);
      asciiCode[4] = `${data.device.serial[3]}`.charCodeAt(0);
      asciiCode[5] = `${data.device.serial[4]}`.charCodeAt(0);
      asciiCode[6] = `${data.device.serial[5]}`.charCodeAt(0);
      asciiCode[7] = data.device.type + 50;
      for (let i = 0; i < data.data.length; i++) {
        asciiCode[i + 8] = data.data[i];
      }
      asciiCode[data.data.length + 8] = hour;
      asciiCode[data.data.length + 9] = minute;
      asciiCode[data.data.length + 10] = days;

      let res = concatenateBuffers(asciiCode, name);
      let token = data.device.bridge_device.internet_token;
      res = concatenateStringAndBuffer(token, res);

      clients[data.device.bridge_device.id].publish(
        data.device.bridge_device.serial + "/sys",
        res,
      );

      setScheduleEquipmentType(null);
      navigate("/planning");
    } else {
      if (!clients[data.device.id]) return;

      let buffer = new ArrayBuffer(data.data.length + 3);
      let asciiCode = new Uint8Array(buffer);
      for (let i = 0; i < data.data.length; i++) {
        asciiCode[i] = data.data[i];
      }
      asciiCode[data.data.length] = hour;
      asciiCode[data.data.length + 1] = minute;
      asciiCode[data.data.length + 2] = days;

      console.log('ascii code is', asciiCode);

      let res = concatenateBuffers(asciiCode, name);
      let token = data.device.internet_token;
      res = concatenateStringAndBuffer(token, res);

      clients[data.device.id].publish(data.device.serial + "/sys", res);

      setScheduleEquipmentType(null);
      navigate("/planning");
    }
  };

  const shouldShowAstronomicalOption = data.device && (data.device.fw_version >= 18 || data.device.fw_version == 13 || data.device.fw_version == 14);

  const provinceOptions = provinces.map(province => ({
    value: province.id,
    name: province.name
  }));

  return (
    <>
      <div
        className="card h-100"
        style={{ backgroundColor: "transparent", boxShadow: "none" }}
      >
        <div className="card-header d-flex align-items-center justify-content-between border-bottom mb-3 p-0 pt-2">
          <h5>زمان بندی</h5>
          <button
            type="button"
            className="btn btn-icon btn-success-app"
            onClick={handleSubmit}
          >
            <span className="tf-icons bx bx-check"></span>
          </button>
        </div>
        <div className="card-body schedule scrollbar">
          <div className="row mx-0">
            <div className="col-12">
              <div className="my-1">
                <label htmlFor="schedule-name" className="form-label">
                  نام برنامه
                </label>
                <input
                  type="text"
                  id="schedule-name"
                  className="form-control"
                  value={scheduleName}
                  onChange={(e) => changeScheduleName(e)}
                />
              </div>
              {data.data.length && !data.icon ? (
                <div
                  className="command-icon mx-auto my-1 state-0"
                  style={{ alignContent: "center" }}
                  onClick={() => {
                    handleSelectEquipmentModal(true);
                  }}
                >
                  <div>
                    <span>{data.name}</span>
                  </div>
                </div>
              ) : data.data.length && data.icon ? (
                <div
                  className="command-img"
                  onClick={() => {
                    handleSelectEquipmentModal(true);
                  }}
                >
                  <img
                    className="mt-1"
                    src={
                      EquipmentButtonIcons.find((icon) => icon.id == data.icon)
                        .path
                    }
                  />
                  {data.device.type == 1 ||
                  data.device.type == 2 ||
                  data.device.type == 7 ||
                  data.device.type == 8 ||
                  data.device.type == 10 ||
                  data.device.type == 11 ||
                  data.device.type == 12 ||
                  data.device.type == 13 ||
                  data.device.type == 14 ||
                  data.device.type == 15 ||
                  (data.data[1] >= 65 && data.data[1] <= 84) ? (
                    <div
                      className={
                        data.data[2]
                          ? "status-part bg-success mx-auto"
                          : "status-part bg-danger mx-auto"
                      }
                    ></div>
                  ) : null}
                  <div>
                    <span>{data.name}</span>
                  </div>
                </div>
              ) : (
                <div
                  className="add-equipment-schedule text-center mb-4"
                  onClick={() => {
                    handleSelectEquipmentModal(true);
                  }}
                >
                  <i className="bx bx-plus"></i>
                </div>
              )}
              
              {shouldShowAstronomicalOption && data.data.length > 0 && (
                <div className="schedule-mode-selector my-1 text-center">
                  <label className="form-label d-block"></label>
                  <div className="segmented-buttons" style={{ display: "inline-flex", borderRadius: "8px", overflow: "hidden", border: "1px solid #dee2e6" }}>
                    <button
                      type="button"
                      onClick={() => setScheduleMode("normal")}
                      className={`segmented-btn ${scheduleMode == "normal" ? "active" : ""}`}
                      style={{
                        padding: "8px 20px",
                        fontSize: "14px",
                        fontWeight: "500",
                        border: "none",
                        backgroundColor: scheduleMode == "normal" ? "#00a594" : "#fff",
                        color: scheduleMode == "normal" ? "#fff" : "#495057",
                        cursor: "pointer",
                        transition: "all 0.2s ease",
                        borderRight: "1px solid #dee2e6"
                      }}
                    >
                      عادی
                    </button>
                    <button
                      type="button"
                      onClick={() => setScheduleMode("sunrise")}
                      className={`segmented-btn ${scheduleMode == "sunrise" ? "active" : ""}`}
                      style={{
                        padding: "8px 20px",
                        fontSize: "14px",
                        fontWeight: "500",
                        border: "none",
                        backgroundColor: scheduleMode == "sunrise" ? "#00a594" : "#fff",
                        color: scheduleMode == "sunrise" ? "#fff" : "#495057",
                        cursor: "pointer",
                        transition: "all 0.2s ease",
                        borderRight: "1px solid #dee2e6"
                      }}
                    >
                      طلوع
                    </button>
                    <button
                      type="button"
                      onClick={() => setScheduleMode("sunset")}
                      className={`segmented-btn ${scheduleMode == "sunset" ? "active" : ""}`}
                      style={{
                        padding: "8px 20px",
                        fontSize: "14px",
                        fontWeight: "500",
                        border: "none",
                        backgroundColor: scheduleMode == "sunset" ? "#00a594" : "#fff",
                        color: scheduleMode == "sunset" ? "#fff" : "#495057",
                        cursor: "pointer",
                        transition: "all 0.2s ease"
                      }}
                    >
                      غروب
                    </button>
                  </div>
                </div>
              )}
              
              {scheduleEquipmentType == 9 || scheduleEquipmentType == 4 ? (
                <div className="Gradual implementation">
                  <span>اجرای تدریجی (دقیقه)</span>
                  <LinearSlider
                    value={fadeValue}
                    setValue={setFadeValue}
                    min={0}
                    max={60}
                  />
                </div>
              ) : null}
            </div>
          </div>

          {scheduleMode == "normal" || !shouldShowAstronomicalOption ? (
            <div className="time-selector mb-4">
              <label className="form-label d-block mb-2 text-center">زمان اجرا</label>
              <div className="d-flex justify-content-center align-items-center gap-3" dir="ltr">
                <div style={{ width: "100px" }}>
                  <Select2
                    setValue={setHourValue}
                    parentElem='body'
                    options={hourOptions}
                    value={hourValue}
                  />
                </div>
                <span className="fs-4 fw-bold">:</span>
                <div style={{ width: "100px" }}>
                  <Select2
                    setValue={setMinuteValue}
                    parentElem='body'
                    options={minuteOptions}
                    value={minuteValue}
                  />
                </div>
              </div>
            </div>
          ) : (
            <div className="astronomical-fields mb-4">
              <div className="mb-1">
                <label htmlFor="province-select" className="form-label">
                  مرکز استان
                </label>
                <div ref={provinceSelectRef} dir="ltr">
                  <Select2
                    setValue={setSelectedProvince}
                    parentElem='body'
                    options={provinceOptions}
                    value={selectedProvince}
                  />
                </div>
              </div>
              <div className="mb-1">
                <label htmlFor="delay-advance-select" className="form-label">
                  تاخیر/تقدم (دقیقه)
                </label>
                <div ref={delayAdvanceSelectRef} dir="ltr">
                  <Select2
                    setValue={handleDelayAdvanceChange}
                    parentElem='body'
                    options={delayAdvanceOptions}
                    value={delayAdvanceDisplayValue}
                  />
                </div>
                <small className="text-muted d-block mt-1">
                  انتخاب کنید برنامه نسبت به زمان طلوع/غروب با چه تاخیر(+) یا تقدم (-) اجرا شود
                </small>
              </div>
            </div>
          )}
          
          <div className="weekly-select">
            <Weekly
              selectedDays={selectedDays}
              setSelectedDays={setSelectedDays}
            />
          </div>
        </div>
      </div>
      <SelectEquipmentModal
        mode={"schedule"}
        closeSelectEquipmentRef={closeSelectEquipmentRef}
        closeSelectOutputEquipmentRef={closeSelectOutputEquipmentRef}
        handleSelectOutputEquipmentModal={handleSelectOutputEquipmentModal}
      />
      <SelectScheduleOutputEquipmentModal
        setSelectOutputModal={setSelectOutputModal}
        closeSelectEquipmentRef={closeSelectEquipmentRef}
        closeSelectOutputEquipmentRef={closeSelectOutputEquipmentRef}
        data={data}
        setData={setData}
      />
    </>
  );
};

export default Schedule;